import React from "react";
import { connect } from "react-redux";
import {
  getGroupData,
  getGroupDataFields
} from "Portal/CallForPapersForm/selectors";
import { getters, actions } from "Portal/CallForPapersForm/model";
import InputFields from "./InputFields";

const decorate = connect(
  state => ({
    data: getGroupData(state),
    groupValues: getters.groupValues(state),
    groupDataFields: getGroupDataFields(state)
  }),
  {
    updateGroupValues: actions.updateGroupValues
  }
);

const GroupPage = ({
  handlers,
  data,
  updateGroupValues,
  groupValues,
  groupDataFields
}) => (
  <>
    <InputFields
      handlers={handlers}
      data={data}
      values={groupValues}
      updateValues={updateGroupValues}
      fields={groupDataFields}
    ></InputFields>
  </>
);

export default decorate(GroupPage);
